import { render } from "./MMAdminAbout.vue?vue&type=template&id=b88045c4"
import script from "./MMAdminAbout.vue?vue&type=script&lang=js"
export * from "./MMAdminAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__